import { Vector3, Geometry, Face3, Group, Mesh, MeshBasicMaterial, EdgesGeometry, LineBasicMaterial, DoubleSide, LineSegments, BufferGeometry } from "three";
/**
 * Physics objects that make up an event in CMS that are not a part of {@link PhoenixObjects}.
 */
var CMSObjects = /** @class */ (function () {
    function CMSObjects() {
    }
    /**
     * Process the Muon Chamber from the given parameters.
     * and get it as a geometry.
     * @param muonChamberParams Parameters of the Muon Chamber.
     * @returns Muon Chamber object.
     */
    CMSObjects.getMuonChamber = function (muonChamberParams) {
        var faces = [];
        var backs = [];
        for (var _i = 0, _a = Object.keys(muonChamberParams); _i < _a.length; _i++) {
            var param = _a[_i];
            if (param.startsWith('front')) {
                faces.push(new Vector3().fromArray(muonChamberParams[param]));
            }
            else if (param.startsWith('back')) {
                backs.push(new Vector3().fromArray(muonChamberParams[param]));
            }
        }
        var box = new Geometry();
        box.vertices = faces.concat(backs);
        // front
        box.faces.push(new Face3(0, 1, 2));
        box.faces.push(new Face3(2, 3, 0));
        // back
        box.faces.push(new Face3(4, 5, 6));
        box.faces.push(new Face3(6, 7, 4));
        // top
        box.faces.push(new Face3(4, 5, 1));
        box.faces.push(new Face3(1, 0, 4));
        // bottom
        box.faces.push(new Face3(7, 6, 2));
        box.faces.push(new Face3(2, 3, 7));
        // left
        box.faces.push(new Face3(0, 3, 7));
        box.faces.push(new Face3(7, 4, 0));
        // right
        box.faces.push(new Face3(1, 5, 6));
        box.faces.push(new Face3(6, 2, 1));
        box.computeFaceNormals();
        box.computeVertexNormals();
        var boxBuffer = new BufferGeometry().fromGeometry(box);
        var boxObject = new Mesh(boxBuffer, new MeshBasicMaterial({
            color: 0xff0000,
            transparent: true,
            opacity: 0.1,
            side: DoubleSide
        }));
        boxObject.userData = muonChamberParams;
        boxObject.name = 'MuonChamber';
        // These are the lines along the box edges
        var boxEdges = new EdgesGeometry(boxBuffer);
        var lineBoxObject = new LineSegments(boxEdges, new LineBasicMaterial({
            color: 0xffffff,
            transparent: true,
            opacity: 0.7
        }));
        var muonChamber = new Group();
        muonChamber.add(boxObject);
        muonChamber.add(lineBoxObject);
        muonChamberParams.uuid = boxObject.uuid;
        return muonChamber;
    };
    return CMSObjects;
}());
export { CMSObjects };
//# sourceMappingURL=cms-objects.js.map